<template>
  <div class="layout__position-left layout__width-100 layout__margin__bottom-10">
    <el-form
      :model="searchParams"
      status-icon
      ref="searchParams"
    >
      <div class="layout__padding-clear text__align-center layout__width-100">
        <div class="layout__search-field__insights-250px">
          <p class="layout__margin__bottom-10 text__align-left">Date Range</p>
          <el-form-item prop="revenueDateRange">
            <el-date-picker
              v-model="searchParams.revenueDateRange"
              type="daterange"
              align="left"
              start-placeholder="Start Date"
              end-placeholder="End Date"
              :picker-options="pickerOptions"
              format="dd/MM/yyyy"
              value-format="yyyy/MM/dd"
            />
          </el-form-item>
        </div>
      </div>
    </el-form>

    <el-button
      class="button-red button__base button__insights"
      @click="getSales()"
    >
      Refresh Data
    </el-button>

    <el-button
      class="button-teal button__base button__insights"
      :disabled="!this.sales.length"
      @click="csv()">
      Download CSV
    </el-button>
  </div>
</template>

<script>
import Axios from 'axios';
import { axios } from '@/mixins/Axios.js';
import { csvDownloadHelper } from '@/mixins/CsvDownloadHelper.js';
import { dataFormatter } from '@/mixins/DataFormatter.js';

export default {
  name: 'newCustomerRevenueSearch',

  mixins: [
    axios,
    csvDownloadHelper,
    dataFormatter,
  ],

  props: {
    sales: Array,
  },

  data() {
    return {
      serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
      exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
      downloadUrl: '',
      searchParams: {
        revenueDateRange: this.getDateRange(),
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date();
        },

        shortcuts: [{
          text: 'This month',

          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          },
        }, {
          text: 'This year',

          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: 'Last 6 months',

          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
    };
  },

  computed: {
    revenueParams() {
      return {
        StartDate: this.searchParams.revenueDateRange[0],
        EndDate: this.searchParams.revenueDateRange[1],
      };
    },
  },

  mounted() {
    this.getSales();
  },

  methods: {
    getSales() {
      const endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetNewCustomerRevenue';

      this.$parent.loading = true;

      Axios.get(endpoint, {
        ...this.returnHeaderUsingToken(),
        params: this.revenueParams,
      })
        .then(response => {
          const orders = response.data.customerRevenue;

          const noColReqd = ['orderYear', 'orderMonth', 'new', 'newsales', 'totalsales'];
          this.$parent.columns = [];

          Object.keys(orders[0]).forEach(key => {
            const columnName = key.toString();

            if (noColReqd.indexOf(columnName) < 0) {
              this.$parent.columns.push({ 'label': columnName, 'prop': columnName, 'min-width': '120px' });
            }
          });

          this.$parent.sales = orders;

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });

          this.$parent.sales = [];
        });
    },

    csv() {
      const endpoint = this.serviceRouteUrl + '/api/v1/insights/order/GetNewCustomerRevenueDetailsCsv';

      this.$parent.loading = true;

      Axios.get(endpoint, {
        ...this.returnHeaderUsingToken(),
        params: this.revenueParams,
      })
        .then(response => {
          const orders = response.data.customerRevenueDetailsCsv,
            monthNames = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE', 'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'],
            noColReqd = ['orderYear', 'orderMonth', 'territory', 'new', 'newsales', 'totalsales'];

          const fields = [
            { label: 'Month', value: (row) => monthNames[row.orderMonth - 1] },
            { label: 'Year', value: 'orderYear' },
            { label: 'Territory', value: 'territory' },
            { label: 'New', value: 'new' },
            { label: 'New First Order Sales Value', value: 'newsales' },
          ];

          Object.keys(orders[0]).forEach(key => {
            const columnName = key.toString();

            if (noColReqd.indexOf(columnName) < 0) {
              fields.push({ 'label': columnName, 'value': columnName });
            }
          });

          fields.push({ 'label': 'Total New Customer Value', 'value': 'totalsales' });

          this.downloadCsv(this.exportDate, fields, orders);

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });
        })
        .catch(error => {
          if (error.response) {
            this.$message.error('Sorry there has been an issue retrieving the information you requested.');
          }

          this.$nextTick(() => { // Loading should be closed asynchronously
            this.$parent.loading = false;
          });
        });
    },

    getDateRange() {
      // get the curren date, and year ago date. Prevent date mutable
      const currentDate = new Date();
      const firstDay = new Date(new Date(currentDate.getTime()).setMonth(new Date(currentDate.getTime()).getMonth() - 9));

      // replace with dates needed
      return [
        `${firstDay.getFullYear()}/${firstDay.getMonth() + 1}/${firstDay.getDate()}`,
        `${currentDate.getFullYear()}/${currentDate.getMonth() + 1}/${currentDate.getDate()}`,
      ];
    },
  },
};
</script>